import { Tabs, TabsContent, TabsList, TabsTrigger } from "@workspace/web-ui/components/tabs"
// import EncountersTag from "./components/encounters-tag"
import EmptyState from "./empty-state"

export default function EncountersDetailsOverview ({encounter}:{encounter:any}) {
    return (
        <div className="flex flex-col gap-[16px]">
            <div className="flex flex-col gap-[8px] border-b border-[#0404041A] pb-[16px] px-[20px]">
                <h1 className="text-[#000000] text-[18px] font-medium leading-[130%] tracking-[-2%]">Basic Information</h1>
                <div className="flex flex-wrap  items-center gap-[19px]">                 
                 <span className="text-[#464B55] text-[14px] leading-[140%] font-normal tracking-[-1%]">Started:{encounter?.session?.start_datetime}</span>
                 <span className="text-[#464B55] text-[14px] leading-[140%] font-normal tracking-[-1%]">Status: <span className="font-medium">{encounter?.session?.onboard_session ==='ended' && encounter?.session?.alfie_session === 'ended' ? "Closed":"In progress"}</span></span>
                 <span className="text-[#464B55] text-[14px] leading-[140%] font-normal tracking-[-1%]">Cost: <span className="font-medium">$--</span></span>
            </div>
            </div>
            <div className="flex flex-col gap-[16px]">
            <h1 className="text-[#1A202C] text-[18px] px-[16px] font-medium leading-[130%] tracking-[-2%]">Diagnosis</h1>
            {typeof encounter?.session?.diagnosis === 'object' && encounter?.session?.diagnosis?.length && encounter?.session?.diagnosis?.length > 0 ? encounter?.session?.diagnosis?.map((diagnosis:any, index:number)=>(
                <div key={index} className="flex flex-col gap-[16px]">            
                <div className="flex flex-col gap-[8px] px-[16px]">
                <h1 className="text-[#1A202C] text-[24px] font-medium leading-[130%] tracking-[-2%]">{diagnosis?.disease_name}</h1>

                <div className="flex flex-col gap-[8px]">
                    <span className="text-[#1A202C] text-[16px] leading-[137%] font-medium tracking-[-1%]">Overview</span>
                    <p className="text-[#464B55] text-[16px] leading-[140%] font-normal tracking-[-1%]">{diagnosis?.overview}</p>
                </div>
                <div className="flex flex-wrap gap-[12px]">
                  {
                    diagnosis.image_urls?.map((src:any, index:number) => (
                        <img key={index} className="w-[136px] rounded-[8px] h-[136px]" src={src} alt="" />
                    ))
                  }
                </div>

            </div>
             <div className="flex flex-col gap-[8px] px-[16px]">
                    <span className="text-[#1A202C] text-[16px] leading-[137%] font-medium tracking-[-1%]">Symptoms</span>
                    <div className="">
                    <ul className="list-disc list-inside grid grid-cols-2 justify-between gap-[8px] text-[#464B55] text-[16px] leading-[140%] font-normal tracking-[-1%]">
                       {
                        diagnosis.symptoms?.map((symptom:any, index:number) => (
                            <li key={index}>{symptom}</li>
                        ))
                       }
                    </ul>
                    </div>
              </div>
              <div className="flex flex-col gap-[8px] px-[16px]">
                    <div className="flex flex-col gap-[8px] border border-[#0404041A] bg-[#F1F4F9] rounded-[12px]">              
                         <Tabs defaultValue="Causes" className="w-full">
                            <TabsList className="flex w-full justify-between h-auto overflow-x-scroll rounded-none my-0 gap-2 border-b bg-transparent px-0 py-0">
                                <TabsTrigger 
                                    value="Causes" 
                                    className="text-[#464B55] text-[14px] leading-[140%] font-normal !my-0 tracking-[-1%] px-3 py-[8px] rounded-none border-b-2 border-transparent !bg-transparent data-[state=active]:border-[#4272DD] data-[state=active]:text-[#4272DD] transition-all"
                                >
                                    Causes
                                </TabsTrigger>
                                <TabsTrigger 
                                    value="Diagnosis" 
                                    className="text-[#464B55] text-[14px] leading-[140%] font-normal !my-0 tracking-[-1%] px-3 py-[8px] rounded-none border-b-2 border-transparent !bg-transparent data-[state=active]:border-[#4272DD] data-[state=active]:text-[#4272DD] transition-all"
                                >
Diagnosis                                </TabsTrigger>
                                <TabsTrigger 
                                    value="Treatment" 
                                    className="text-[#464B55] text-[14px] leading-[140%] font-normal !my-0 tracking-[-1%] px-3 py-[8px] rounded-none border-b-2 border-transparent !bg-transparent data-[state=active]:border-[#4272DD] data-[state=active]:text-[#4272DD] transition-all"
                                >
                                    Treatment
                                </TabsTrigger>
                            </TabsList>
                            <TabsContent value="Causes" className=" p-[10px]">
                                                  <ul className="list-disc list-inside text-[#464B55] text-[14px] leading-[140%] font-normal tracking-[-1%]">
                       {
                        diagnosis?.causes?.map((cause:any, index:number) => (
                            <li key={index}>{cause}</li>
                        ))
                       }
                    </ul>

                             </TabsContent>
                            <TabsContent value="Diagnosis" className="p-[8px]">
                                                  <ul className="list-disc list-inside text-[#464B55] text-[14px] leading-[140%] font-normal tracking-[-1%]">
                       {
                        diagnosis?.diagnosis?.map((cause:any, index:number) => (
                            <li key={index}>{cause}</li>
                        ))
                       }
                    </ul>
                            </TabsContent>
                            <TabsContent value="Treatment" className="p-[8px]">

                                                  <ul className="list-disc list-inside text-[#464B55] text-[14px] leading-[140%] font-normal tracking-[-1%]">
                                            {diagnosis?.treatment_page?.medications?.length > 0 ? (
                        <ul className="list-disc pl-5 space-y-1">
                          {diagnosis?.treatment_page?.medications?.map((treatment:any, index:number) => (
                            <li key={index} className="text-sm">
                              <strong>{treatment.medication} ({treatment.category})</strong>: {treatment.instructions.join(', ')}
                            </li>
                          ))}
                        </ul>
                      ) : (
                                        <EmptyState title="No treatment information available." message="" type="prescription" />
                      )}
                    </ul>
                            </TabsContent>
                        </Tabs>
                    </div> 
              </div>

              </div>
              )):                  
              <div className="px-[20px]">
                      <EmptyState title="No diagnosis yet" message="To receive a diagnosis, please continue your chat with Alfie." type="diagnosis2" />
                </div>
                }
                    <div className="flex flex-col gap-[8px] px-[16px]">
                    <h1 className="text-[#1A202C] text-[18px] font-medium leading-[130%] tracking-[-2%]">Doctors note</h1>
                    <div>  
                       <EmptyState title="No diagnosis yet" message="A note will appear here after you’ve had a consultation with a doctor." type="doctors_note" />
                  
                        <ul className="list-disc hidden pl-4  text-[#464B55] text-[16px] leading-[140%] font-normal tracking-[-1%]">
                       {
                        Array.from({ length: 2 }).map((_, index) => (
                            <li key={index} className="mb-4">
                              <div className="flex flex-col gap-[8px] ">         
                                <p className="text-[#464B55] text-[14px] leading-[140%] font-normal tracking-[-1%]">Patient presented with classic symptoms of URTI. Prescribed antibiotic treatment. Advised rest and increased fluid intake. </p>
                                <span className="text-[#464B55] text-[12px] leading-[140%] underline font-normal tracking-[-1%]">24 April, 2025 - Follow up appointment</span>
                              </div>
                             </li>
                        ))
                       }
                    </ul>
                  </div>
              </div>
        </div>

        </div>
    )
}